import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef  } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from '@app/store/index';
import * as LayoutActions from '@app/store/layout/layout.actions';
import * as AsideItemActions from '@app/store/aside-item/aside-item.actions';
import { SaveChild, ResetModalContent } from '../../../store/aside-item/aside-item.actions';
import * as AsideActions from '@app/store/aside/aside.actions';
import { ResourcesService } from '@app/shared/services/resources.service';
import { first } from 'rxjs/operators';
import { ConsoleUtils } from '@app/shared/helpers/console-utils';
import { environment } from '@environments/environment';
// import { PDFDocumentProxy, PDFPageProxy } from 'pdfjs-dist';

declare var noScroll: any;

@Component({
    selector: 'app-modal-resource',
    templateUrl: './modal-resource.component.html',
})
export class ModalResourceComponent implements OnDestroy {
    openModalResource: boolean;

    modalContent: any;
    hasBtnOnFooter: boolean;
    isSaving: boolean;
    hideActions: boolean;

    title: string;
    mode: string;
    fileData: any;

    public documentPdf: string = null;
    private documentPdfObjectUrl: string = null;
    @ViewChild('iframe', {static: false}) iframe: ElementRef;


    private suscriptionsToManage$: Subscription[] = [];

    constructor(
        private store: Store<AppState>,
        private resourcesService: ResourcesService
    ) {

        this.initSuscriptions();

    }

    ngOnDestroy() {
        this.releaseDocumentPdfUrl();
        this.suscriptionsToManage$.forEach(subscription => subscription.unsubscribe());
    }

    initSuscriptions() {

        this.suscriptionsToManage$.push(this.store.select(state => state.layout.openModalResource).subscribe(res => {
            this.openModalResource = res;
        }));

        this.suscriptionsToManage$.push(this.store.select(state => state.asideItem.modalContent).subscribe(res => {
            this.modalContent = res;

            if (this.openModalResource && this.modalContent) {
                this.init();
            }
        }));
    }

    init() {
        this.title = this.modalContent.name;
        this.mode = this.modalContent.typeName;
        // ConsoleUtils.log('mode init', this.mode);
        // ConsoleUtils.log('modalContent', this.modalContent);

        if (this.mode === 'PDF' || this.mode === 'Imagen' || this.mode === 'Documento') {
            this.getFile();
        }
        // this.hasBtnOnFooter = false;
    }

    reset() {
        this.mode = '';
        this.title = '';

        this.releaseDocumentPdfUrl();

        this.documentPdf = null;
        this.fileData = null;
    }

    close() {
        this.reset();

        this.store.dispatch(new AsideActions.ChangeHide(false));
        this.store.dispatch(new AsideItemActions.ResetModalContent());
        this.store.dispatch(new LayoutActions.CloseModalResource());
    }

    getFile() {
        this.resourcesService.open(this.modalContent.book_id, this.modalContent.id).pipe(
            first()).subscribe(data => {
                const base64File = data.file;

                /*
                 * Se conserva fileData en formato data URL porque se utiliza
                 * en los iframes de recursos.
                 */
                this.fileData = 'data:application/pdf;base64,' + base64File;

                /*
                 * Para el visor PDF.js creamos una URL temporal de Blob.
                 * Es más fiable que pasar directamente una cadena base64 grande.
                 */
                if (this.mode === 'PDF' && this.modalContent.in_viewer) {
                    this.releaseDocumentPdfUrl();

                    const bytes = this.base64ToUint8Array(base64File);

                    const blob = new Blob([bytes], {
                        type: 'application/pdf'
                    });

                    this.documentPdfObjectUrl =
                        window.URL.createObjectURL(blob);

                    this.documentPdf =
                        this.documentPdfObjectUrl;
                }
            });
    }

    private releaseDocumentPdfUrl() {
        if (!this.documentPdfObjectUrl) {
            return;
        }

        window.URL.revokeObjectURL(
            this.documentPdfObjectUrl
        );

        this.documentPdfObjectUrl = null;
    }

    private base64ToUint8Array(value: string): Uint8Array {
        /*
         * La API puede devolver:
         * - base64 puro
         * - una data URL completa: data:application/pdf;base64,...
         * - base64 con saltos de línea/espacios
         * - base64 URL-safe (- y _)
         */
        let base64 = value || '';

        const commaIndex = base64.indexOf(',');
        if (base64.indexOf('data:') === 0 && commaIndex >= 0) {
            base64 = base64.substring(commaIndex + 1);
        }

        base64 = base64
            .replace(/\s/g, '')
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        while (base64.length % 4 !== 0) {
            base64 += '=';
        }

        const binary = window.atob(base64);
        const bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }

        return bytes;
    }

    downloadPdf() {
        const linkSource = 'data:application/pdf;base64,' + this.fileData;
        const downloadLink = document.createElement("a");
        const fileName = "sample.pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    getPdfFile() {
        // console.log('this.modalContent', this.modalContent);
        // console.log('getPdfFile /storage/resources/', this.modalContent.file);
        return '/storage/resources/' + this.modalContent.file;
    }
}
